import { defineMessages } from 'react-intl';

export const estimationItemsTableMessageDefinitions = defineMessages({
  estimate: {
    id: 'estimationDetail.estimationItemsResourceCostSummaryTable.estimate',
    defaultMessage: 'Estimate',
  },
  totalSum: {
    id: 'estimationDetail.estimationItemsResourceCostSummaryTable.subtotal',
    defaultMessage: 'Subtotal',
  },
  totalEfforts: {
    id: 'estimationDetail.estimationItemsResourceCostSummaryTable.totalEfforts',
    defaultMessage: 'Total Efforts',
  },
});
